import securityQuestionnaireDictionary from '@widgets/about-security-questionnaire/i18n/ru/security-questionnaire.json';
import additionalInformationDictionary from '@widgets/additional-information/i18n/ru/additional-information.dic.json';
import educationStepDictionary from '@widgets/education/i18n/ru/education.dic.json';
import workExperienceDictionary from '@widgets/work-experience/i18n/ru/work-experience.dic.json';

export const securityQuestionnaire = {
  SECURITY_QUESTIONNAIRE: securityQuestionnaireDictionary,
  EDUCATION_STEP: educationStepDictionary,
  WORK_EXPERIENCE_STEP: workExperienceDictionary,
  ADDITIONAL_INFORMATION_STEP: additionalInformationDictionary,
};

export const securityQuestionnaireNamespaces = Object.keys(
  securityQuestionnaire
);
